import { injectable as __injectable } from 'inversify';
import type { Constructor } from '@/inversify.types';

export function injectable() {
    // eslint-disable-next-line func-names
    return function (constructor: Constructor) {
        return __injectable()(constructor);
    };
}
